<template>
    <section class="bg--white m-0 position-relative p-0 activities-overview">
        <div class="container-fluid">
            <div class="row">
                <div class="side side--sticky col-12 col-lg-3">
                    <activities-filter
                        :title-filters="titleFilters"
                        :button-text="buttonText"
                        :options="options"
                        :filters="filters"
                    ></activities-filter>
                </div>
                <div class="main col-12 col-lg-8 col-xl-7 offset-xl-1 py-3">
                    <div class="row mb-5">
                        <activities-search
                            :search-term="filterSet.searchTerm"
                            :search-term-location="filterSet.searchTermLocation"
                            @search="searchTermValue"
                            @searchLocation="searchTermLocationValue"
                        ></activities-search>
                        <div class="col-12 col-md-6">
                            <div
                                class="toggle-btn"
                                :class="filterSet.selectedView"
                            >
                                <div class="toggle-btn__option">
                                    <input
                                        v-model="filterSet.selectedView"
                                        value="view--list"
                                        type="radio"
                                        class="toggle-btn__checkbox"
                                        @click="changeView('view--list')"
                                    />
                                    <span>
                                        <i class="fas fa-list"></i>
                                        Lijst</span
                                    >
                                </div>
                                <div class="toggle-btn__option">
                                    <input
                                        v-model="filterSet.selectedView"
                                        value="view--map"
                                        type="radio"
                                        class="toggle-btn__checkbox"
                                        @click="changeView('view--map')"
                                    />
                                    <span>
                                        <i class="fas fa-map"></i>
                                        Kaart</span
                                    >
                                </div>
                                <div class="toggle-btn__overlay"></div>
                            </div>
                        </div>
                    </div>
                    <activities-results
                        v-if="
                            filterSet.activities &&
                                filterSet.selectedView === 'view--list'
                        "
                        :activities="filterSet.activities"
                    ></activities-results>
                    <div
                        v-if="
                            !filterSet.loading &&
                                filterSet.activities.length === 0
                        "
                        class="row"
                    >
                        <div class="col-12 position-relative no-results">
                            <h3>Er zijn geen resultaten gevonden</h3>
                        </div>
                    </div>
                    <div class="w-100 d-flex justify-content-center">
                        <spinner v-if="filterSet.loading" />
                        <button
                            v-if="
                                !filterSet.loading &&
                                    filterSet.currentPage <
                                        filterSet.pageCount - 1
                            "
                            class="btn btn-secondary w-auto"
                            @click="getNextPage"
                        >
                            <span>Meer resultaten laden</span>
                        </button>
                    </div>
                </div>
                <activities-map-results
                    v-if="
                        filterSet.activities &&
                            filterSet.selectedView === 'view--map'
                    "
                    :activities="filterSet.activities"
                ></activities-map-results>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import activitiesFilter from '@/components/activities-filter';
import activitiesSearch from '@/components/activities-search';
import activitiesResults from '@/components/activities-results';
import activitiesMapResults from '@/components/activities-map-results';
import spinner from '@/components/spinner';
export default {
    components: {
        activitiesFilter,
        activitiesSearch,
        activitiesResults,
        activitiesMapResults,
        spinner
    },
    props: {
        titleFilters: {
            type: String,
            default: ''
        },
        buttonText: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            options: {
                targetAudience: '',
                schoolTimes: '',
                educationLevel: '',
                theme: '',
                provider: '',
                coreGoal: '',
                duration: '',
                lessonType: '',
                targetGroup: ''
            },
            filters: {
                targetAudience: '',
                schoolTimes: '',
                educationLevel: '',
                theme: [],
                provider: [],
                coreGoal: [],
                duration: [],
                lessonType: '',
                targetGroup: ''
            },
            filterSet: {
                activities: [],
                pageCount: 0,
                selectedFilters: '',
                currentPage: 0,
                loading: false,
                searchTerm: '',
                searchTermLocation: '',
                firstLoad: 0,
                activityUrl: '/activiteiten/',
                selectedView: 'view--list'
            },
            path: '',
            randomize: true,
            firstLoad: true,
            nextPage: false
        };
    },
    computed: {
        joinedFilters() {
            const filterList = [];

            [...this.filters.theme].forEach(theme => {
                filterList.push(theme.filter);
            });

            [...this.filters.provider].forEach(provider => {
                filterList.push(provider.filter);
            });

            [...this.filters.coreGoal].forEach(coreGoal => {
                filterList.push(coreGoal.filter);
            });

            [...this.filters.duration].forEach(duration => {
                filterList.push(duration.filter);
            });

            if (
                this.filters.targetGroup != 0 &&
                this.filters.targetGroup != null
            ) {
                filterList.push(this.filters.targetGroup.filter);
            }

            if (
                this.filters.schoolTimes != 0 &&
                this.filters.schoolTimes != null
            ) {
                filterList.push(this.filters.schoolTimes.filter);
            }

            if (
                this.filters.targetAudience != 0 &&
                this.filters.targetAudience != null
            ) {
                filterList.push(this.filters.targetAudience.filter);
            }

            if (
                this.filters.educationLevel != 0 &&
                this.filters.educationLevel != null
            ) {
                filterList.push(this.filters.educationLevel.filter);
            }

            if (
                this.filters.lessonType != 0 &&
                this.filters.lessonType != null
            ) {
                filterList.push(this.filters.lessonType.filter);
            }

            return filterList.filter(Boolean).join(',');
        }
    },
    watch: {
        filters: {
            handler() {
                if (this.filterSet.firstLoad > 0) {
                    this.filterSet.selectedFilters = this.joinedFilters;
                    this.filterSet.currentPage = 0;

                    this.filterSet.activities = [];
                    this.getActivities();
                }

                this.filterSet.firstLoad++;
            },
            deep: true
        },
        'filterSet.searchTerm': {
            handler(oldValue, newValue) {
                if (oldValue !== newValue) {
                    this.filterSet.currentPage = 0;
                    this.randomize = true;
                    if (this.filterSet.firstLoad !== 0) {
                        this.filterSet.activities = [];
                        this.searchTimeOut();
                    }
                }
            }
        },
        'filterSet.searchTermLocation': {
            handler() {
                this.filterSet.currentPage = 0;
                this.randomize = true;
                if (this.filterSet.firstLoad !== 0) {
                    this.filterSet.activities = [];
                    this.searchTimeOut();
                }
            }
        }
    },
    created() {
        const filters = JSON.parse(sessionStorage.getItem('all-filters'));

        if (filters) {
            this.filterSet.firstLoad = 0;
        } else {
            this.filterSet.firstLoad = 1;
        }

        this.getActivityUrl();

        if (this.$route.query.viewType) {
            this.filterSet.selectedView = this.$route.query.viewType;
        }

        if (
            this.$route.query.filters ||
            this.$route.query.keywords ||
            this.$route.query.locations
        ) {
            if (this.$route.query.filters) {
                this.filterSet.selectedFilters = this.$route.query.filters;
                this.filterSet.firstLoad = 0;
            }

            if (this.$route.query.keywords) {
                this.filterSet.searchTerm = this.$route.query.keywords;
            }

            if (this.$route.query.locations) {
                this.filterSet.searchTermLocation = this.$route.query.locations;
            }

            if (this.filterSet.firstLoad === 0) {
                this.filterSet.activities = [];
                this.getActivities();
            }
        } else {
            this.getActivities();
        }
    },
    methods: {
        createPath: function() {
            this.path =
                this.filterSet.activityUrl +
                '?locations=' +
                this.filterSet.searchTermLocation +
                '&keywords=' +
                this.filterSet.searchTerm +
                '&filters=' +
                this.filterSet.selectedFilters +
                '&viewType=' +
                this.filterSet.selectedView;
            this.$router.replace({ path: this.path }).catch(() => {});
            sessionStorage.setItem('filtered-url', this.path);
        },
        searchTimeOut: function() {
            this.filterSet.loading = true;
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.getActivities();
            }, 400);
        },
        changeView: function(className) {
            this.filterSet.selectedView = className;
            this.filterSet.activities = [];
            this.getActivities();
        },
        searchTermValue: function(params) {
            this.filterSet.searchTerm = params;
        },
        searchTermLocationValue: function(params) {
            this.filterSet.searchTermLocation = params;
        },
        getActivities() {
            if (this.firstLoad && !this.nextPage) {
                if (sessionStorage.getItem('all-activities') != null) {
                    this.filterSet.activities = JSON.parse(
                        sessionStorage.getItem('all-activities')
                    );
                }

                if (sessionStorage.getItem('all-filters') != null) {
                    this.filterSet.selectedFilters = JSON.parse(
                        sessionStorage.getItem('all-filters')
                    );
                }

                if (sessionStorage.getItem('search-term') != null) {
                    this.filterSet.searchTerm = JSON.parse(
                        sessionStorage.getItem('search-term')
                    );
                }
            }

            this.filterSet.loading = true;
            this.createPath();
            const self = this;
            axios
                .post('/api/activity/filteredactivities', {
                    activities: self.filterSet.activities,
                    filters: self.filterSet.selectedFilters,
                    searchTerm: self.filterSet.searchTerm,
                    searchTermLocation: self.filterSet.searchTermLocation,
                    page: self.filterSet.currentPage,
                    type: self.filterSet.selectedView,
                    randomize: self.randomize
                })
                .then(response => {
                    if (self.filterSet.firstLoad == 0) {
                        for (const key of Object.keys(self.options)) {
                            response.data.filters[key].filters.forEach(
                                filter => {
                                    if (
                                        filter.isChecked == true &&
                                        response.data.filters[key]
                                            .isMultiSelect == true
                                    ) {
                                        self.filters[key].push(filter);
                                    } else if (filter.isChecked == true) {
                                        self.filters[key] = filter;
                                    }
                                }
                            );
                        }
                    }
                    this.randomize = true;
                    this.options = response.data.filters;
                    this.filterSet.pageCount = response.data.pageCount;
                    this.filterSet.activities = response.data.results;
                    if (!this.firstLoad) {
                        sessionStorage.setItem(
                            'all-activities',
                            JSON.stringify(this.filterSet.activities)
                        );

                        sessionStorage.setItem(
                            'all-filters',
                            JSON.stringify(this.filterSet.selectedFilters)
                        );

                        sessionStorage.setItem(
                            'search-term',
                            JSON.stringify(this.filterSet.searchTerm)
                        );
                    }

                    this.firstLoad = false;
                })
                .finally(() => {
                    this.filterSet.loading = false;
                });
        },
        getActivityUrl() {
            axios.get('/api/activity/activityurl').then(response => {
                this.filterSet.activityUrl = response.data;
            });
        },
        getNextPage() {
            if (this.filterSet.currentPage < this.filterSet.pageCount) {
                this.filterSet.currentPage += 1;
                this.nextPage = true;
                this.randomize = true;
                this.getActivities();
            }
        }
    }
};
</script>

<style lang="scss">
.no-padding {
    padding-top: 0px !important;
}

.no-results {
    z-index: 30;
}

.toggle-btn {
    position: relative;
    width: 300px;
    height: 54px;
    overflow: hidden;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.05);
    border-radius: 28px;
    background-color: $white;
    z-index: 10;
}

input.toggle-btn__checkbox {
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 0;
    left: 0;
    top: 0;
    margin: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
}

.toggle-btn__overlay {
    z-index: 2;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.toggle-btn__overlay:before,
.toggle-btn__overlay:after,
.toggle-btn__option {
    position: absolute;
    top: 0;
    width: 50%;
    height: 100%;
    font-size: 1rem;
    text-align: center;
    padding: 8px 4px;
    border-radius: 28px;
    transition: 0.3s ease color, 0.3s ease left;
}

.toggle-btn__overlay:before {
    content: '';
    left: 0;
    background-color: $blue-7;
}

.toggle-btn__option:nth-child(2) {
    right: 0;
    color: $blue-7;
}

.toggle-btn__option {
    display: inline-block;
    color: $white;
    z-index: 3;
    font-family: $headings-font-family;
}

.view--map {
    margin: 2rem auto 0;

    @include media-breakpoint-up(md) {
        margin: 0;
    }
}

.view--map .toggle-btn__overlay:before {
    left: 50%;
    background-color: $blue-7;
}

.view--map .toggle-btn__option {
    color: $blue-7;
}

.view--map .toggle-btn__option:nth-child(2) {
    color: $white;
}
</style>
